/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum draftIncludeEnum {
    ALL = 'all',
    DRAFT = 'draft',
    COMPLETED = 'completed',
}